import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../apiConfig';
import moment from 'moment';

const createQueryParams = (page, pageSize, filters) => {
  const params = new URLSearchParams();
  
  if (page) params.append('page', page);
  if (pageSize) params.append('page_size', pageSize);
  if (filters) {
    Object.keys(filters).forEach((key) => {
      if (filters[key]) params.append(key, filters[key]);
    });
  }

  return params.toString();
};

// export const fetchCollectionOxyzo = createAsyncThunk(
//   'collection/fetchCollectionOxyzo',
//   async ({ jwtBearer, page, pageSize, filters } = {}) => {
//     const queryParams = createQueryParams(page, pageSize, filters);
//     const response = await axios.get(`${BASE_URL}oxyzo/collection/data/${queryParams ? `?${queryParams}` : ''}`, {
//       headers: {
//         Authorization: `Bearer ${jwtBearer}`
//       }
//     });
//     return response.data;
//   }
// );


export const fetchCollectionOxyzo = createAsyncThunk(
  'collection/fetchCollectionOxyzo',
  async ({ jwtBearer, page, pageSize, filters } = {}, { rejectWithValue }) => {
    try {
      const queryParams = createQueryParams(page, pageSize, filters);
      const response = await axios.get(
        `${BASE_URL}oxyzo/collection/data/${queryParams ? `?${queryParams}` : ''}`,
        {
          headers: {
            Authorization: `Bearer ${jwtBearer}`
          }
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.reload();
      }
      console.error('Fetch error:', error);
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);


export const fetchFilteredCollectionOxyzo = createAsyncThunk(
  'collection/fetchFilteredCollectionOxyzo',
  async ({ jwtBearer, filters } = {}) => {
    const queryParams = createQueryParams(null, null, filters);
    const response = await axios.get(`${BASE_URL}oxyzo/collection/data/${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);


// export const downloadOxyzoReport = createAsyncThunk(
//   "downloadOxyzoReport",
//   async ({ jwtBearer, type, startDate, endDate }, { rejectWithValue }) => {
//     try {
//       let filePrefix = type === "collection" ? "Collection_Oxyzo" : "All_Loan_Oxyzo";
//       let fileName = `${filePrefix}_${startDate || "report"}.xlsx`;

//       if (startDate && endDate) {
//         fileName = `${filePrefix}_${startDate}_to_${endDate}.xlsx`;
//       }

//       const response = await fetch(`${BASE_URL}oxyzo/report/download/`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${jwtBearer}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           type,
//           start_date: startDate,
//           end_date: endDate,
//         }),
//       });

//       if (!response.ok) {
//         throw new Error("Failed to generate report");
//       }

//       const blob = await response.blob();
//       const downloadUrl = URL.createObjectURL(blob);

//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.download = fileName;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       URL.revokeObjectURL(downloadUrl);
//     } catch (error) {
//       console.error("Error downloading oxyzo report:", error);
//       return rejectWithValue(error.message);
//     }
//   }
// );

export const downloadOxyzoReport = createAsyncThunk(
  "downloadOxyzoReport",
  async ({ jwtBearer, type, startDate, endDate }, { rejectWithValue }) => {
    try {
      let filePrefix = "";

      if (type === "collection") {
        filePrefix = "Collection_Oxyzo";
      } else if (type === "due") {
        filePrefix = "Due_Oxyzo";
      } else if (type === "all_loan") {
        filePrefix = "All_Loan_Oxyzo";
      }
      else if (type === "loan_portfolio") {
        filePrefix = "Loan_Portfolio";
      }
      else {
        throw new Error("Invalid report type");
      }

      let fileName = `${filePrefix}_${startDate || "report"}.csv`;

      if (startDate && endDate) {
        fileName = `${filePrefix}_${startDate}_to_${endDate}.csv`;
      }

      const response = await fetch(`${BASE_URL}oxyzo/report/download/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${jwtBearer}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type,
          start_date: startDate,
          end_date: endDate,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to generate report");
      }

      const blob = await response.blob();
      const downloadUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Error downloading oxyzo report:", error);
      return rejectWithValue(error.message);
    }
  }
);



const collectionOxyzoSlice = createSlice({
  name: 'oxyzoCollection',
  initialState: {
    data: [],
    loading: false,
    error: null,
    totalCount: 0,

    filteredData: [],
    filteredLoading: false,
    filteredError: null,
    filteredTotalCount: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCollectionOxyzo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCollectionOxyzo.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.collection_data; 
        console.log("state.data--",state.data)
        state.totalCount = action.payload.data.total_collection_data; 
      })
      .addCase(fetchCollectionOxyzo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchFilteredCollectionOxyzo.pending, (state) => {
        state.filteredLoading = true;
        state.filteredError = null;
      })
      .addCase(fetchFilteredCollectionOxyzo.fulfilled, (state, action) => {
        state.filteredLoading = false;
        state.filteredData = action.payload.data.collection_data;
        state.filteredTotalCount = action.payload.data.total_collection_data || 0; 
      })
      .addCase(fetchFilteredCollectionOxyzo.rejected, (state, action) => {
        state.filteredLoading = false;
        state.filteredError = action.error.message;
      });
  }
});

export default collectionOxyzoSlice.reducer;
